import { render, staticRenderFns } from "./miniappPannel.vue?vue&type=template&id=c462acbc"
import script from "./miniappPannel.vue?vue&type=script&lang=js"
export * from "./miniappPannel.vue?vue&type=script&lang=js"
import style0 from "./miniappPannel.vue?vue&type=style&index=0&id=c462acbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports